// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { translate } from '@application/common/helpers/translate';
import { verifyUserAsync } from '@application/features/shufftiPro/ShufftiProThunks';
import { useAppDispatch } from '@application/store/useStore';
import { Box, Dialog, Typography } from '@mui/material';
import { PrimaryButon } from '@ui/components/common/button/PrimaryButon';
import { black400 } from '@ui/constants/color';
export const WelcomMsg = ({ handleClose, open }) => {
    const dispatch = useAppDispatch();
    const onSubmit = () => {
        dispatch(verifyUserAsync({}));
    };
    return (_jsx(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, children: _jsxs(Box, { width: 620, p: 5, sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center'
            }, children: [_jsx(Typography, { fontSize: '34px', fontWeight: 500, color: 'initial', children: translate('kyc.welcomeTitle') }), _jsx(Typography, { variant: 'subtitle1', color: black400, children: translate('kyc.welcomeMessage') }), _jsx(Box, { width: 300, mt: 2, children: _jsx(PrimaryButon, { type: 'submit', onClick: onSubmit, children: translate('kyc.start') }) })] }) }));
};
